// Fase 1A — Servicio de sucursales (thin wrapper de axios). Solo lecturas (listado/selección).
// NO incluye el CRUD admin (POST/PUT/DELETE) — fuera del alcance de bajo riesgo.
import api from "@/lib/api";

// Listado de sucursales. `config` opcional se pasa tal cual a axios (p.ej. { params: { empresa_id } }).
export const listSucursales = (config) => api.get("/sucursales", config);

export const getSucursal = (id) => api.get(`/sucursales/${id}`);
